module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroller"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("promItem"), _vm._v(" "), (_vm.type === 'hasCover') ? _c('ul', {
    staticClass: "hasCover"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": 'subject/' + item.id,
        "append": ""
      }
    }, [(item.images) ? _c('img', {
      attrs: {
        "src": item.images.large,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.rating) ? _c('rating', {
      attrs: {
        "rating": item.rating
      }
    }) : _vm._e()], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.type === 'onlyString') ? _c('ul', {
    staticClass: "onlyString"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticStyle: {
        "border-color": "#FFAC2D"
      }
    }, [(!item.line) ? _c('a', {
      style: ({
        color: item.color
      }),
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()])
  })) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76ac51e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scroller.vue
// module id = 204
// module chunks = 0